import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';

import CoefficientSummaryTableRow from './CoefficientSummaryTableRow';

class CoefficientSummaryTableComponent extends React.PureComponent {
  static propTypes = {
    coefficientSummary: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        tScore: PropTypes.number.isRequired,
        pValue: PropTypes.number.isRequired,
        stderr: PropTypes.number.isRequired,
        estimate: PropTypes.number.isRequired
      }).isRequired
    ).isRequired
  }

  getColumns = () => [
    'Parameter',
    'Coefficient`s Estimate',
    'Standard Error',
    `${this.props.isProbabilityPlot ? 't Statistic' : 't Score'}`,
    'p-value'
  ];

  render () {
    return (
      <div
        id="coefficient-summary-table"
        className="content-item mb-15"
      >
        <p className="font-700 mb-10">
          Coefficient Summary Table
        </p>

        <table className="main-table">
          <thead>
            <tr>
              {this.getColumns().map(column =>
                <th className="text-right" key={column}>
                  {column}
                </th>
              )}
            </tr>
          </thead>

          <tbody>
            {map(this.props.coefficientSummary, (coefficientSummaryChunk, index) =>
              <CoefficientSummaryTableRow {...coefficientSummaryChunk} key={index} index={index} />
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

CoefficientSummaryTableComponent.propTypes = {
  isProbabilityPlot: PropTypes.bool.isRequired
};

export default CoefficientSummaryTableComponent;
